import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PageCard } from '@/components/ui/page-card'
import { Text } from '@/components/ui/text'
import { commonSearchSchema, generateTitle } from '@/lib/utils'

export const Route = createFileRoute('/_auth/success')({
  validateSearch: commonSearchSchema.extend({
    // The flow that just finished (an AuthFlow kind); see completedSearch.
    completed: z.enum(['account', 'legacy', 'handoff', 'guestUpgrade']).optional(),
  }),
  component: Success,
  head: () => ({ meta: [{ title: generateTitle('Authorization Complete') }] }),
})

function Success() {
  const { completed, gameId } = Route.useSearch()
  // Guest upgrades and handoffs come from a game; only the legacy flow can come from another app.
  const fromGame = completed === 'guestUpgrade' || completed === 'handoff'

  return (
    <PageCard
      title={completed === 'guestUpgrade' ? 'Guest Progress Saved' : 'Authorization Complete'}
      description={
        completed === 'guestUpgrade' ? (
          <>
            Your guest progress in <b>{gameId}</b> is now linked to your Argus account.
          </>
        ) : fromGame ? (
          'Your game can now finish signing you in.'
        ) : (
          'Your app can now finish signing you in.'
        )
      }
    >
      <Text block>
        {fromGame ? 'Return to your game.' : 'Return to your game or app.'} You can close this tab.
      </Text>
    </PageCard>
  )
}
